import { render, staticRenderFns } from "./CoinDialog.vue?vue&type=template&id=57dd9c8d&scoped=true&"
import script from "./CoinDialog.vue?vue&type=script&lang=js&"
export * from "./CoinDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoinDialog.vue?vue&type=style&index=0&id=57dd9c8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd9c8d",
  null
  
)

export default component.exports